import { useQuery } from '@tanstack/react-query';
import { getRentDepositInsurance } from '@/api/rentDepositInsurance/getRentDepositInsurance';

type RentDepositInsuranceQueryOptions = {
  staleTime?: number;
  refetchOnWindowFocus?: boolean | 'always';
};

export const useGetRentDepositInsurance = (
  enabled: boolean,
  realEstateObjectId?: string,
  options: RentDepositInsuranceQueryOptions = {},
) => {
  const { isLoading, data, isError } = useQuery({
    queryKey: ['rent-deposit-insurance', realEstateObjectId],
    queryFn: getRentDepositInsurance,
    enabled,
    refetchOnWindowFocus: false,
    useErrorBoundary: false,
    ...options,
  });

  return {
    initializing: isLoading,
    policy: data?.currentNonTerminatedPolicy,
    isError,
  };
};
